import * as React from 'react';
// import { SignIn, SignUp, useUser, ClerkProvider } from '@clerk/clerk-react'; // Removed Clerk imports
import { PageLoader, LOADER_MESSAGES } from './components/ui/loader';
import { Outlet } from 'react-router-dom';
import { UpdateButton } from './components/update-button';
import { VersionPill } from './components/ui/version-pill';
import { UserMenu } from './components/ui/user-menu';
import { useWeb3Auth } from './providers/Web3AuthProvider'; // Import useWeb3Auth
import { useAffiliateIntegration } from './hooks/useAffiliateIntegration'; // Import useAffiliateIntegration

const RANDOM_MESSAGE =
	LOADER_MESSAGES[Math.floor(Math.random() * LOADER_MESSAGES.length)];
const LOADER = <PageLoader message={RANDOM_MESSAGE} />;

// AuthStateWrapper component for conditional rendering based on auth state
function AuthStateWrapper({ children }: { children: React.ReactNode }) {
	const { isWeb3AuthLoading } = useWeb3Auth();

	// Initialize affiliate tracking
	useAffiliateIntegration();

	if (isWeb3AuthLoading) {
		return LOADER;
	}

	return <>{children}</>;
}

function App() {
	return (
		<React.Suspense fallback={LOADER}>
			<AuthStateWrapper>
				<UserMenu />
				<VersionPill />
				<UpdateButton />
				<Outlet />
			</AuthStateWrapper>
		</React.Suspense>
	);
}

export default App;
